import React, { useState } from 'react';
import { Box } from '@mui/material';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import StatusFilterTabs from '../../Components/Tab/tab.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import CommonTabs from './common-tab.tsx';
import QueryWidget from '../../Components/QueryWidget/query-widget.tsx'
import './driver_style.scss';

interface DriversProps {}

const Drivers: React.FC<DriversProps> = () => {
  const [activeTab, setActiveTab] = useState('Drivers');
  const [tabsWithData, setTabsWithData] = useState<string[]>([]);
  const [viewedTabs, setViewedTabs] = useState<string[]>(['Drivers']);

  const handleClose = () => {};
  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    
    setViewedTabs((prevViewedTabs) => {
      if (!prevViewedTabs.includes(newTab)) {
        return [...prevViewedTabs, newTab];
      }
      return prevViewedTabs;
    });
    
    const tabNameMap: { [key: string]: string } = {
      'Drivers': 'driver',
      'Left': 'left',
      'Blacklist': 'blacklist',
      'Others': 'others',
      'Leads': 'lead',
      'Owner': 'owner'
    };
    
    const newTabName = tabNameMap[newTab];
    
    sessionStorage.setItem('opened_blinking_tab', newTabName);
  };

  const handleSetTabsWithData = (tabs: string[]) => {
    setTabsWithData(tabs);
  };

  const handleResetViewedTabs = (newActiveTab: string) => {
    setViewedTabs([newActiveTab]);
  };
  const renderTabContent = (tab: string) => {
    switch (tab) {
      case 'Drivers':
        return <CommonTabs tabName="driver" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      case 'Left':
        return <CommonTabs tabName="left" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      case 'Blacklist':
        return <CommonTabs tabName="blacklist" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      case 'Others':
         return <CommonTabs tabName="others" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      case 'Leads':
         return <CommonTabs tabName="lead" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      case 'Owner':
           return <CommonTabs tabName="owner" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData} onResetViewedTabs={handleResetViewedTabs}/>;
      default:
        return <CommonTabs tabName="driver" setActiveTab={setActiveTab} onTabsWithDataChange={handleSetTabsWithData}/>;
    }
  };

  return (
    <>
      <Header/>
      <Box sx={{ flexGrow: 1, marginTop:'70px' }}> 
        <Heading title="Drivers" closeIcon="false" onClose={handleClose} />
      </Box>
      
      <Box sx={{ marginBottom: 2, marginLeft: { xs: '10px', sm: '180px' } }}>
         <StatusFilterTabs 
            tabs={['Drivers', 'Left', 'Blacklist', 'Others', 'Leads', 'Owner']}
            activeTab={activeTab} 
            onTabChange={handleTabChange}
            tabsWithData={tabsWithData}
            viewedTabs={viewedTabs}
         />
                            
        <Box sx={{ marginLeft: { xs: '10px', sm: '0px' } }}>
            {renderTabContent(activeTab)}
        </Box>
         <QueryWidget />
      </Box>
      <NavBar selected="Drivers" />
    </>
  );
};

export default Drivers;